export const OPEN_AI_KEY = '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';